import { PharmacErrorToast, PharmacSuccessToast, usePharmacToast } from '@pharmac/ui'
import { useMutation } from '@tanstack/react-query'
import { useEffect, useState } from 'react'
import { useForm } from 'react-hook-form'
import { useTranslation } from 'react-i18next'
import { useCustomerContext } from '../../features/customer/CustomerProvider'
import { api } from '../../services/HttpService'

export const useResetApiKey = () => {
  const { customer, roles } = useCustomerContext()
  const [showPassword, setShowPassword] = useState(false)
  const [showConfirmationModal, setShowConfirmationModal] = useState(false)
  const { add } = usePharmacToast()
  const { t } = useTranslation()

  const formHook = useForm({
    defaultValues: {
      apiKey: '',
    },
  })
  const defaultInputValue = '*******************'
  useEffect(() => {
    formHook.reset({
      apiKey: defaultInputValue,
    })
  }, [])

  const getNewKey = async () => {
    if (!customer?.id) return
    const response = await api.customers.resetCustomerApiKey(customer.id)

    return response
  }

  const copyToClipboard = async () => {
    const inputValue = formHook.getValues().apiKey
    if (!showPassword || inputValue === defaultInputValue) return

    try {
      await navigator.clipboard.writeText(inputValue)
      add({
        toast: <PharmacSuccessToast>{t('clipboardSuccess', { ns: 'common' })}</PharmacSuccessToast>,
      })
    } catch (error: any) {
      add({
        toast: <PharmacErrorToast>{t('clipboardError', { ns: 'common' })}</PharmacErrorToast>,
      })
    }
  }

  const { mutate } = useMutation({
    mutationFn: () => getNewKey(),
    onSuccess: (response) => {
      if (typeof response === 'string') {
        formHook.setValue('apiKey', response)
        setShowPassword(true)
        setShowConfirmationModal(false)
      }
    },
  })

  return {
    formHook,
    setShowConfirmationModal,
    handleReset: mutate,
    showPassword,
    copyToClipboard,
    showConfirmationModal,
    isAdmin: roles?.isAdmin,
    isPharmacy: customer?.type === 'pharmacy',
  }
}
